<!-- 指导模板管理，bluesky:2023-10-05 -->
<template>
  <div class="manage-section">

    <div class="breadcrumb-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>管理后台</el-breadcrumb-item>
        <el-breadcrumb-item>指导模板管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索-start -->
    <div class="search-wrap">

      <div class="search-item">
          <div class="btn-list-wrap">
              <el-button type="info" @click="clickAdd">添加</el-button>
          </div>
      </div>

    </div>
    <!-- 搜索-end -->

    <!-- 表格-start -->
    <div class="table-wrap">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="编号"
            >
          </el-table-column>
          <el-table-column
            prop="regulateTypeName"
            label="监管类型"
            >
          </el-table-column>
          <el-table-column
            prop="stageOrderName"
            label="监管阶段"
            >
          </el-table-column>

          <el-table-column
            prop="title"
            label="标题"
            >
          </el-table-column>

          <el-table-column
            prop="main_desc"
            label="主要指导内容"
            >
          </el-table-column>


          <el-table-column
            prop="hasTreeDesc"
            label="是否显示植被指导内容">
            <template slot-scope="{row}">
            	<div>{{row.hasTreeDesc == 1 ? "是" : "否"}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hasWeatherDesc"
            label="是否显示天气提示"
            >
            <template slot-scope="{row}">
            	<div>{{row.hasWeatherDesc == 1 ? "是" : "否"}}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="添加时间"
            >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            >
          </el-table-column>
          <el-table-column
          	label="状态">
          	<template slot-scope="{row}">
          		{{ row.status == 1 ? "启用": "停用"}}
          	</template>
          </el-table-column>
          <el-table-column
          	label="操作">
              <template slot-scope="{row}">
                  <div class="flex-center operate">
                      <!-- <el-button type="info" size="mini" @click="clickToggle(row.id,row.status)">{{ row.status == 1?"停用":"启用" }}</el-button> -->
                      <el-button type="info" size="mini" @click="clickEdit(row.id)">修改</el-button>
                      <el-button type="info" size="mini" @click="clickDelete(row.id)">删除</el-button>
                  </div>
              </template>
          </el-table-column>
        </el-table>

       <div class="pager-wrap">
         <el-pagination
             background
             layout="prev, pager, next"
         	@current-change="pageChange"
             :page-size="search.pageSize"
                :total="totalCount">
         </el-pagination>
       </div>

    </div>
    <!-- 表格-end -->

    <el-dialog :visible.sync="isShowPopup" width="800px">
    	<div class="popup-title" slot="title">{{idInput?'修改':'添加'}}指导模板</div>
    	<addOrEditTipsTpl :idInput="idInput" @close="closePopup" @success="finishPublish" v-if="isShowPopup"></addOrEditTipsTpl>
    </el-dialog>

  </div>
</template>

<script>
  import addOrEditTipsTpl from '@/page/components/addOrEditTipsTpl.vue';
  export default {
    components:{
      addOrEditTipsTpl,// 添加/修改指导模板
    },
    data() {
      return {
        search:{
          keyword:null,// 关键词
          type:null,// 类型
        },
        totalCount:0,// 总数量
        totalPageCount:0,//总页码数

        typeList:[],

        tableData: [],

        isShowPopup:false,// 是否显示弹窗
        idInput:null,// 修改时传入ID
      }
    },
    mounted() {
      this.getList();
    },
    methods:{
      //改变页码
      pageChange(pageIndex){
      	this.search.pageIndex = pageIndex;
      	this.getList();
      },
      // 改变月份
      changeMonthList(){
        this.search.pageIndex = 1;
        this.getList();
      },
      // 改变类型
      changeType(){
        this.search.pageIndex = 1;
        this.getList();
      },
      // 点击搜索
      clickSearch(){
        this.search.pageIndex = 1;
        this.getList();
      },
      //获取列表
      getList(){
      	this.$apis.get('/admin/tipsTpl/list', this.search).then(res => {
      		console.log("res",res);
          if(res.data.code == 200){
      			this.tableData = res.data.data;
      			//this.totalPageCount = res.data.data.totalPageCount;
      		}
      		else{
      			this.$message({
      			    message:res.data.data,
      			    type:'error'
      			});
      		}
      	});
      },

                //添加
                clickAdd(){
                	this.isShowPopup = true;
                	this.idInput = null;
                },
                //修改
                clickEdit(id){
                	this.isShowPopup = true;
                	this.idInput = id;
                },
                //启用、停用
                clickToggle(id,oldStatus){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.post('/admin/tipsTpl/toggle', {
                			id:id,
                      status:oldStatus == 1 ? 0 : 1,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                // 删除
                clickDelete(id){
                	this.$confirm(`你确定要继续吗？`, '提示', {
                		confirmButtonText: '确定',
                		cancelButtonText: '取消',
                		type: 'warning'
                	}).then(() => {
                		this.$apis.get('/admin/tipsTpl/delete', {
                			id:id,
                		}).then((res) => {
                			if (res.data.code == 200) {
                				this.getList();
                				this.$message.success('操作成功！');
                			}
                			else{
                				this.$message({
                				    message:res.data.data,
                				    type:'error'
                				});
                			}
                		})
                	}).catch(() => {});
                },
                //完成添加/修改操作后的回调
                finishPublish(){
                	this.isShowPopup = false;
                	this.getList();
                },
                //关闭弹窗
                closePopup(){
                	this.isShowPopup = false;
                },


                },
  }
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// src/page/tipsTplManage.vue